export const uiWebinarLink = {
    name: 'UI Webinar Link',
    description: '',
    displayField: 'title',
    fields: {
        title: {
            name: 'Title',
            type: 'Symbol',
            required: true,
            localized: true,
            disabled: false,
            omitted: false,
            validations: []
        },
        url: {
            name: 'URL',
            type: 'Symbol',
            required: true,
            localized: false,
            disabled: false,
            omitted: false,
            validations: []
        },
        appearance: {
            name: 'Appearance',
            type: 'Symbol',
            required: false,
            localized: false,
            disabled: false,
            omitted: false,
            validations: [{ in: ['Default', 'Webinars page'] }]
        }
    }
};
//# sourceMappingURL=uiWebinarLink.js.map